var exports = {
  "i": "xe533113f--9739d8--wrapper",
};

module.exports = exports;
